import { MapPin, Phone, Mail, Truck, PackageOpen, ExternalLink } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_swiss-logistics/artifacts/qc38gmzs_LOGO-TRANSP.png";
const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=Rue+des+Remparts+7+1400+Yverdon-les-Bains+Suisse";

export default function Footer() {
  return (
    <footer id="contact" className="bg-[#050505] border-t border-[#1A1A1A] pt-16 pb-8" data-testid="footer-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Logo & Description */}
          <div>
            <img
              src={LOGO_URL}
              alt="Janyel's Transport Service Sàrl — Transport et déménagement professionnel en Suisse"
              className="h-14 w-auto mb-6"
              data-testid="footer-logo"
            />
            <p className="text-white/50 text-sm leading-relaxed">
              Votre partenaire de confiance pour le transport de marchandises et le déménagement dans toute la Suisse. Fiabilité, professionnalisme et ponctualité.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-['Oswald'] text-lg font-bold uppercase text-white mb-6 tracking-wider">Services</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/50 text-sm hover:text-white/80 transition-colors">
                <Truck className="w-4 h-4 text-[#FF0000]" />
                Transport de marchandises
              </li>
              <li className="flex items-center gap-3 text-white/50 text-sm hover:text-white/80 transition-colors">
                <PackageOpen className="w-4 h-4 text-[#FF0000]" />
                Déménagement
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Oswald'] text-lg font-bold uppercase text-white mb-6 tracking-wider">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={MAPS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-white/50 text-sm hover:text-white/80 transition-colors group"
                  data-testid="footer-address"
                >
                  <MapPin className="w-4 h-4 text-[#FF0000] mt-0.5 flex-shrink-0" />
                  <span>Rue des Remparts 7<br />1400 Yverdon-les-Bains</span>
                  <ExternalLink className="w-3 h-3 text-white/20 group-hover:text-white/50 mt-0.5 flex-shrink-0 transition-colors" />
                </a>
              </li>
              <li>
                <a href="tel:+41788313353" className="flex items-center gap-3 text-white/50 text-sm hover:text-white/80 transition-colors" data-testid="footer-phone">
                  <Phone className="w-4 h-4 text-[#FF0000]" />
                  078 831 33 53
                </a>
              </li>
              <li>
                <a href="mailto:devis@janyels.ch" className="flex items-center gap-3 text-white/50 text-sm hover:text-white/80 transition-colors" data-testid="footer-email">
                  <Mail className="w-4 h-4 text-[#FF0000]" />
                  devis@janyels.ch
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#1A1A1A] pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-xs">
            &copy; 2026 Janyel's Transport Service Sàrl — Tous droits réservés
          </p>
          <p className="text-white/20 text-xs">
            Site créé par <a href="https://www.lynk.marketing" target="_blank" rel="noopener noreferrer" className="hover:text-white/40 transition-colors underline">Lynk</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
